import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SlideContentConfig } from '../models/slide-text-content-config';
import { SlideContentPipelineService } from '../services/slide-content-pipeline.service';

@Pipe({
    name: 'slideContentHtml',
    standalone: false
})

export class SlideContentHtmlPipe implements PipeTransform {

  constructor(private readonly slideContentPipelineService: SlideContentPipelineService) { }

  transform(value: SlideContentConfig, element: HTMLElement): Observable<SafeHtml> {
    return this.slideContentPipelineService.process(value, element);
  }
}
